import { render } from "./xterm.vue?vue&type=template&id=6687e70a&scoped=true"
import script from "./xterm.vue?vue&type=script&lang=js"
export * from "./xterm.vue?vue&type=script&lang=js"

import "./xterm.vue?vue&type=style&index=0&id=6687e70a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6687e70a"]])

export default __exports__